import { CREATE_NEW_MEMBER_ERROR, CREATE_NEW_MEMBER_SUCCESS,
    CREATE_NEW_MEMBER_ADMIN_ERROR, CREATE_NEW_MEMBER_ADMIN_SUCCESS } from '../actions/index';
import { createReducer } from '../common/utils/ApiUtils';

const initialState = {
    memberCreated: false,
    memberResponse: null,
    memberAdminCreated: false,
    memberAdminResponse: null
};

export default createReducer(initialState, {
    [CREATE_NEW_MEMBER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            memberCreated: true,
            memberResponse: payload
        });
    },
    [CREATE_NEW_MEMBER_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            memberCreated: false,
            memberResponse: payload
        });
    },
    [CREATE_NEW_MEMBER_ADMIN_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            memberAdminCreated: true,
            memberAdminResponse: payload
        });
    },
    [CREATE_NEW_MEMBER_ADMIN_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            memberAdminCreated: false,
            memberAdminResponse: payload
        });
    },
});
